import { FormFieldTypes } from "../../../../../data/formFieldType";

export const AdditionalFieldsData = {
  name: "AdditionalInfo",
  initialState: {
  label: "",
  instructions: "",
  inputType: "Text Box",
  mandatory: "Yes",
},
  formFields: [
    {
      id: "label",
      lable: "Label",
      Field_Name: "Label",
      fieldType: FormFieldTypes.INPUT,
      dataField: "label",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-12 mb-3 pr-0",
      },
    },
    {
      id: "instructions",
      lable: "Instructions",
      Field_Name: "Instructions",
      fieldType: FormFieldTypes.CONFIGURABLE_CKEDITOR,
      dataField: "instructions",
      fieldSetting: {
        placeholder: "",
        allowSpace: false,
        toolbar: [
          'undo',
          'redo',
          '|',
          'heading',
          '|',
          'bold',
          'italic',
          'underline',
          'bulletedList',
          'numberedList',
          'fontFamily',
          'fontColor',
          'fontBackgroundColor',
          'strikethrough',
          'alignment'
        ]
      },
      validation: [],
      style: {
        containerCss: "col-md-12 mb-3 h-40",
      },
    },
    {
      id: "inputType",
      label: "Input Fields",
      Field_Name: "Input Fields",
      fieldType: FormFieldTypes.RADIOBUTTON,
      dataField: "inputType",
      fieldSetting: {
        placeholder: "",
        options: [
          {label: "Text Box", value: "Text Box", isDisable: false },
          {label: "L1-L4 Rating",value: "L1-L4 Rating",isDisable: false,optionClass: "mr-3",},
          {label: "Tick Rating",value: "Tick Rating",isDisable: false,optionClass: "mr-3",},
        ],
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-12 col-12 mb-4 mt-2 x-position radio-gap",
      },
    },
    {
      id: "mandatory",
      label: "Mandatory",
      Field_Name: "Mandatory",
      fieldType: FormFieldTypes.RADIOBUTTON,
      dataField: "mandatory",
      fieldSetting: {
        placeholder: "",
        options: [
          { label: "Yes", value: "Yes", isDisable: false },
          { label: "No", value: "No", isDisable: false, optionClass: "mr-3" },
        ],
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-12 col-12 mb-4 mt-2 x-position radio-gap",
      },
    },
    
  ],
  formSetting: {
    isViewOnly: false,
  },
};
